/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_From_IdeaInputs */

const en_mk_foot_from_idea = /** @type {(inputs: Mk_Foot_From_IdeaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From an idea`)
};

const id_mk_foot_from_idea = /** @type {(inputs: Mk_Foot_From_IdeaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dari ide`)
};

/**
* | output |
* | --- |
* | "From an idea" |
*
* @param {Mk_Foot_From_IdeaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_from_idea = /** @type {((inputs?: Mk_Foot_From_IdeaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_From_IdeaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_from_idea(inputs)
	return en_mk_foot_from_idea(inputs)
});